import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { homePath } from "@/lib/roles";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const run = async () => {
      try {
        const user = await exchangeSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(homePath(user), { replace: true, state: { user } });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      }
    };
    if (sessionId) run();
    else navigate("/login", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-carbon" data-testid="auth-callback">
      <p className="text-silver uppercase tracking-[0.25em] text-sm">Signing you in…</p>
    </div>
  );
}
